import { render, staticRenderFns } from "./UserSettingsProfile.vue?vue&type=template&id=9bc19ba6&scoped=true&"
import script from "./UserSettingsProfile.vue?vue&type=script&lang=js&"
export * from "./UserSettingsProfile.vue?vue&type=script&lang=js&"
import style0 from "./UserSettingsProfile.vue?vue&type=style&index=0&id=9bc19ba6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc19ba6",
  null
  
)

export default component.exports